export default {
  nav: {
    main: 'Principal',
    ordersAndInvoices: 'Encomendas e Faturas',
    drafts: 'Rascunhos',
    automation: 'Automatização',
    workspace: 'Área de Trabalho',
    templates: 'Modelos',
    delivery: 'Entrega',
    settings: 'Configurações',
    shippingLabels: 'Etiquetas de Envio',
    subscriptions: 'Subscrições',
    support: 'Suporte',
    developer: 'Programador',
    writeReview: 'Escrever uma Avaliação',
    supportTicket: 'Pedido de Suporte',
    welcomeTour: 'Tour de Boas-vindas',
    administratorConsole: 'Consola de Administração',
    logout: 'Sair',
  },
  dashboard: {
    pageTitle: 'Encomendas e Faturas',
    pageDescription: 'Manage your orders and invoices',
    title: 'Encomendas e Faturas',
    selectedOrders: '{count} encomendas selecionadas',
    completed: '% concluído',
    processing: 'A processar, por favor aguarde...',
    bulkDownload: 'Transferência em Massa',
    upgradeBulkDownload: 'Atualize o seu plano para Transferência em Massa',
    showFilters: 'Mostrar Filtros',
    hideFilters: 'Ocultar Filtros',
    creatingInvoices: 'A criar faturas, por favor aguarde...',
    bulkCreateInvoices: 'Criar Faturas em Massa',
    cannotCreateAutopilot: 'Não pode criar faturas manualmente quando o modo de faturação está em piloto automático.',
    exportInvoices: 'Exportar faturas ou encomendas',
    capturePayments: 'Capturar Pagamentos Manualmente',
    filterOrders: 'Filtrar encomendas',
    error: 'Algo correu mal...',
    close: 'Fechar',
    chooseDate: 'Escolher uma data',
    chooseIssueDate: 'Escolha uma data de emissão para as faturas selecionadas',
    cancel: 'Cancelar',
    createInvoices: 'Criar Faturas',
    storno: 'Storno',
    bulkOrderCapture: 'Captura de Encomendas em Massa',
  },
  search: {
    createdBetween: 'Criado entre',
    modifiedBetween: 'Modificado entre',
    orderNumber: 'Encomenda #',
    invoiceNumber: 'Fatura #',
    refundNumber: 'Reembolso #',
    customer: 'Cliente',
    payment: 'Pagamento',
    any: 'Qualquer',
    authorized: 'Autorizado',
    pending: 'Pendente',
    paid: 'Pago',
    partiallyPaid: 'Parcialmente pago',
    refunded: 'Reembolsado',
    voided: 'Anulado',
    partiallyRefunded: 'Parcialmente reembolsado',
    unpaid: 'Não pago',
    fulfillment: 'Expedição',
    fulfilled: 'Enviado',
    partial: 'Parcial',
    unfulfilled: 'Não enviado',
    loading: 'A carregar encomendas...',
    search: 'Pesquisar',
  },
  orderList: {
    noCustomer: 'Sem Cliente',
    downloadOrder: 'Transferir Encomenda',
    deleteWarning: 'Importante! Isto irá eliminar todas as faturas e reembolsos criados após a data:',
    includingInvoice: 'incluindo a fatura selecionada #',
    pressOk: 'Prima OK para continuar ou Cancelar para abortar.',
    cannotCreateAutopilot: 'Não pode criar faturas manualmente quando o modo de faturação está em piloto automático.',
    createInvoice: 'Criar fatura para esta encomenda',
    create: 'Criar',
    addCreditNote: 'Adicionar Nota de Crédito',
    createStorno: 'Criar uma Fatura de Storno',
    refund: 'Reembolso',
    downloadInvoice: 'Transferir esta fatura',
    download: 'Transferir',
    default: 'Padrão',
    downloadStorno: 'Transferir este storno/nota de crédito',
    fulfillOrder: 'Expedir Encomenda',
    orderNum: 'Encomenda #',
    locPrefix: 'Prefixo Loc',
    invoiceNum: 'Fatura #',
    refundNum: 'Reembolso #',
    customerCol: 'Cliente',
    orderCreatedDate: 'Data de Criação da Encomenda',
    orderModifiedDate: 'Data de Modificação da Encomenda',
    delivered: 'Entregue',
    paymentStatus: 'Estado do Pagamento',
    fulfillmentStatus: 'Estado de envio',
    totalOutstanding: 'Valor Total em Aberto',
    originalPrice: 'Preço Original',
    noOrders: 'A sua loja não tem encomendas para o estado selecionado.',
    cannotCreateNoOrders: 'Não é possível criar faturas quando não existem encomendas.',
    createOrdersFirst: 'Por favor crie pelo menos uma encomenda e tente novamente.',
    createOrders: 'Criar encomendas',
    loadingOrders: 'A carregar...',
    paidManual: 'Pago - Manual',
    paid: 'Pago',
    refunded: 'Reembolsado',
    pending: 'Pendente',
    partiallyPaid: 'Parcialmente pago',
    partiallyRefunded: 'Parcialmente reembolsado',
    fulfilled: 'Enviado',
    unfulfilled: 'Não enviado',
    deliveryPending: 'Pendente',
    deliverNow: 'Entregar agora',
    deliveryPartial: 'Parcial',
    notDelivered: 'Não entregue',
    deliverAgain: 'Entregar novamente',
    deliveryDetails: 'Detalhes da entrega',
    deliveryFailed: 'Entrega falhada',
    sent: 'Enviado',
    failed: 'Falhado',
    toLabel: 'Para',
    folderLabel: 'Pasta',
    open: 'Aberto',
    invoice: 'Fatura',
    creditNote: 'Nota de crédito',
    stornoLabel: 'Storno',
    unknown: 'Desconhecido',
    googleDrive: 'Google Drive',
    clientsTablet: 'Tablet de clientes',
    shippyPro: 'ShippyPro',
    emailChannel: 'E-mail',
    ftpChannel: 'FTP',
    revertToDate: 'Reverter para esta data',
    add: 'Adicionar',
    close: 'Fechar',
  },
  downloadDialog: {
    downloadType: 'Transferir {type}...',
    selectTemplate: 'Selecione um modelo da galeria para exportar encomendas, faturas, faturas de storno ou notas de crédito.',
    getMoreTemplates: 'Obter mais Modelos',
    createNewTemplate: 'Criar um novo Modelo',
    allCreatedBetween: 'Todos os {type} criados entre',
    selectedType: '{type} selecionados',
    and: 'e',
    status: 'Estado',
    any: 'Qualquer',
    open: 'Aberto',
    closed: 'Fechado',
    cancelled: 'Cancelado',
    paymentStatus: 'Estado do Pagamento',
    fulfillmentStatus: 'Estado de envio',
    fulfilled: 'Enviado',
    partial: 'Parcial',
    unfulfilled: 'Não enviado',
    authorized: 'Autorizado',
    pending: 'Pendente',
    paid: 'Pago',
    partiallyPaid: 'Parcialmente pago',
    refunded: 'Reembolsado',
    voided: 'Anulado',
    partiallyRefunded: 'Parcialmente reembolsado',
    unpaid: 'Não pago',
    format: 'Formato',
    forLocation: 'Para localização',
    advancedOptions: 'Opções avançadas',
    exportHSCodes: 'Exportar códigos HS de inventário (mais lento)',
    noteChrome: 'Nota: Para download ideal recomenda-se o Chrome e desativar qualquer bloqueador de anúncios.',
    downloadIndividually: 'Baixar individualmente',
    downloadGrouped: 'Baixar agrupado',
  },
  templates: {
    pageTitle: 'Modelos',
    pageDescription: 'Customize your invoice templates',
    title: 'Modelos',
    installTranslated: 'Instalar um modelo traduzido',
    installTranslatedDesc: 'Escolha um idioma diferente clicando neste botão.',
    createNew: 'Criar um novo modelo se necessário',
    createNewDesc: 'Clique neste botão para criar um novo modelo se necessário.',
    customize: 'Personalizar modelos',
    customizeDesc: 'Clique no modelo padrão para personalizá-lo. Pode alterar o logotipo, cores e, para utilizadores mais avançados, o código por trás.',
    defaultTemplate: 'Fatura, Storno e Nota de Crédito (Padrão)',
    logo: 'Logotipo',
    colorPalette: 'Paleta de Cores',
    getColorPalettes: 'Obter paletas de cores',
    paperSize: 'Tamanho do Papel',
    format: 'Formato',
    a3: 'A3 (297 x 420 mm)',
    a4: 'A4 (210 x 297 mm)',
    a5: 'A5 (148 x 210 mm)',
    legal: 'Legal (215.9 x 355.6 mm)',
    letter: 'Letter (215.9 x 279.4 mm)',
    tabloid: 'Tabloid (279.4 x 431.8 mm)',
    mcPrint3: 'mC-Print3 Roll (80 x 155 mm)',
    mcPrint2: 'mC-Print2 Roll (57.5 x 155 mm)',
    orientation: 'Orientação',
    landscape: 'Paisagem',
    portrait: 'Retrato',
    margin: 'Margem (cm)',
    unsavedChanges: 'Alterações não guardadas',
    discard: 'Descartar',
    save: 'Guardar',
  },
  labels: {
    pageTitle: 'Etiquetas de Envio',
    pageDescription: 'Create and manage shipping labels',
    title: 'Etiquetas de Envio',
    glsRequiresPro: 'As Etiquetas de Envio GLS para EEU requerem o plano Profissional.',
    upgradeDesc: 'Atualize para Profissional para criar e gerir etiquetas de envio.',
    upgradePlan: 'Atualize o seu plano',
    eeuGls: 'EEU GLS',
    enabled: 'Ativado',
    country: 'País',
    hungary: 'Hungria',
    slovakia: 'Eslováquia',
    czech: 'República Checa',
    romania: 'Romênia',
    slovenia: 'Eslovénia',
    croatia: 'Croácia',
    senderId: 'ID do Remetente',
    username: 'Nome de Utilizador',
    password: 'Palavra-passe',
    name: 'Nome',
    city: 'Cidade',
    address: 'Morada',
    zipCode: 'Código Postal',
    contactPerson: 'Pessoa de Contacto',
    phone: 'Telefone',
    email: 'Email',
    glsServices: 'Serviços GLS',
    expressService: 'Serviço Expresso',
    exchangeService: 'Serviço de Troca',
    smsService: 'Serviço SMS',
    smsText: 'Texto SMS',
    preAdviceService: 'Serviço PreAdvice',
    unsavedChanges: 'Alterações não guardadas',
    discard: 'Descartar',
    save: 'Guardar',
  },
  billing: {
    pageTitle: 'Faturação',
    pageDescription: 'Manage your subscription and billing',
    title: 'Faturação',
    subscriptionFor: 'Plano de subscrição para a loja',
    currentlySubscribed: 'Está atualmente subscrito ao',
    plan: 'plano',
    cancelSubscription: 'Cancelar Subscrição',
    upgradePlan: 'Atualize o seu plano',
    professional: 'Profissional',
    proPriceMonthly: '$29.99 / mês',
    upgrade: 'Atualizar',
    includesAllStarter: 'Inclui todas as funcionalidades do Starter, mais:',
    proFeature1: 'Suite de Conformidade Global: Prefixos baseados em localização e numeração sequencial personalizada',
    proFeature2: 'Localização Inteligente: Emails traduzidos automaticamente e anexos PDF localizados',
    proFeature3: 'Ciclo Completo de Documentos B2B: Proformas, Orçamentos B2B e Notas de Crédito',
    proFeature4: 'Sincronização Contábil B2B: Precisão de 3 casas decimais e visualização multi-moeda',
    proFeature5: 'Backups Automáticos: Copiar faturas automaticamente para FTP seguro ou Google Drive',
    proFeature6: 'Shopify Flow: Automatizar geração, entrega e storno de faturas via triggers e ações do Flow',
    proFeature7: 'Lógica AI Avançada: Utilize a AI no dispositivo para cláusulas de layout condicionais complexas',
    proFeature8: 'Exportações UBL XML & ZUGFeRD / Factur-X (conformidade europeia de faturação eletrónica)',
    proFeature9: 'Códigos EPC QR para pagamentos instantâneos por POS móvel',
    proFeature10: 'Etiquetas de Envio GLS para EEU',
    proFeature11: 'Retenção fiscal de conformidade de 7 anos',
    currentlyUsing: 'Está atualmente a utilizar o nosso',
    free: 'gratuito',
    subscriptionPlan: 'plano de subscrição.',
    monthlyUsage: 'Utilização Mensal',
    monthlyGenerated: '{count} / 50 faturas este mês',
    monthlyLimitReached: 'Limite mensal atingido. Atualize para Starter para faturas ilimitadas.',
    freePlan: 'Plano Gratuito',
    freeToInstall: 'Gratuito para instalar',
    freeFeature1: 'Até 50 faturas/encomendas por mês',
    freeFeature2: 'Acesso a todos os 31+ modelos predefinidos',
    freeFeature3: 'AI Copilot básico',
    freeFeature4: 'Transferências e impressão de PDF padrão',
    freeFeature5: 'Suite de documentos padrão (Faturas, Guias de Remessa, Recibos)',
    freeFeature6: 'Retenção segura de faturas por 3 meses',
    starterPlan: 'Plano Starter',
    starterPrice: '$9.99 / mês',
    starterPricePerInvoice: '+ 3¢ por fatura criada',
    subscribe: 'Subscrever',
    starterFeature1: 'Faturas e encomendas ilimitadas',
    starterFeature2: 'Entrega automática de PDF por email',
    starterFeature3: 'Acesso total ao editor híbrido e AI Copilot',
    starterFeature4: 'Integração com Shopify POS e código de barras',
    starterFeature5: 'Shopify Flow: Triggers e ações para automação de faturas',
    starterFeature6: 'Exportações UBL XML / PEPPOL & ZUGFeRD / Factur-X (conformidade de faturação eletrónica)',
    starterFeature7: 'Retenção segura de faturas por 1 ano',
    proTaxOverrides: 'Substituições Fiscais Personalizadas: IVA por produto e taxas ao nível do SKU',
    unsavedChanges: 'Alterações não guardadas',
    discard: 'Descartar',
    save: 'Guardar',
  },
  autopilot: {
    pageTitle: 'Automatização',
    pageDescription: 'Automate invoice creation and management',
    title: 'Automatização',
    autoCreate: 'Criar Faturas Automaticamente',
    disabled: 'Desativado (Manual)',
    whenCreated: 'Quando as encomendas são criadas',
    whenFulfilled: 'Quando as encomendas são expedidas',
    whenPaid: 'Quando as encomendas são pagas',
    autoCreateDesc: 'As faturas serão criadas na data em que as encomendas são criadas, expedidas ou pagas.',
    autoStorno: 'Storno Automático de Faturas',
    whenCancelled: 'Quando as encomendas são canceladas ou reembolsadas',
    autoStornoDesc: 'As faturas de storno serão criadas na data em que as encomendas são anuladas/canceladas ou os reembolsos são criados.',
    cannotAutoFree: 'A criação automática de faturas não pode ser realizada com o plano gratuito.',
    upgradePlan: 'Atualize o seu plano',
    unsavedChanges: 'Alterações não guardadas',
    discard: 'Descartar',
    save: 'Guardar',
  },
  delivery: {
    pageTitle: 'Entrega',
    pageDescription: 'Configure invoice delivery via email, FTP, or Google Drive',
    title: 'Entrega',
    settings: 'Configurações',
    useOrderNumbers: 'Usar números de encomenda para ficheiros',
    sendIfCountry: 'Enviar se o país do endereço de faturação for',
    countryCodesHint: 'Liste todos os códigos de país separados por ponto e vírgula.',
    sendForTags: 'Enviar para clientes que têm uma das tags listadas',
    tagsHint: 'Liste todas as tags separadas por ponto e vírgula.',
    emailDelivery: 'Entrega por Email',
    sendAsPdf: 'Enviar faturas como anexos PDF para clientes',
    autoSend: 'Enviar automaticamente quando uma fatura é criada',
    subject: 'Assunto',
    body: 'Corpo',
    xmlAttachments: 'Anexos XML',
    attachUbl: 'Anexar UBL/PEPPOL XML (E-Factura)',
    attachZugferd: 'Anexar ZUGFeRD / Factur-X XML',
    sendTestEmail: 'Enviar Email de Teste',
    sending: 'A enviar...',
    customSmtp: 'Servidor SMTP Personalizado',
    customSmtpDesc: 'Usar o seu próprio servidor de email em vez do padrão',
    enableSmtp: 'Ativar SMTP personalizado',
    smtpHost: 'Servidor SMTP',
    port: 'Porta',
    useSsl: 'Usar SSL/TLS',
    username: 'Nome de Utilizador',
    password: 'Palavra-passe',
    fromEmail: 'Email de Origem',
    fromName: 'Nome de Origem',
    shopifyLiquid: 'Modelo Shopify Liquid',
    pasteInto: 'Cole isto no seu',
    orderConfirmation: 'modelo de confirmação de encomenda',
    toAddLink: 'para adicionar um link de transferência.',
    downloadInvoice: 'Transferir a sua fatura',
    clientsTablet: 'ClientsTablet',
    clientsTabletDesc: 'Enviar pedidos para ClientsTablet quando as faturas são criadas',
    shippyPro: 'ShippyPro',
    shippyProDesc: 'Enviar faturas PDF como documentos alfandegários para ShippyPro para países fora da UE',
    ftpBackup: 'Backup FTP/SFTP',
    ftpDesc: 'Copiar faturas automaticamente para o seu servidor',
    enableFtp: 'Ativar backup FTP automático',
    host: 'Servidor',
    useSftp: 'Usar SFTP (seguro)',
    destinationFolder: 'Pasta de destino',
    xmlFiles: 'Ficheiros XML',
    includeUbl: 'Incluir UBL/PEPPOL XML (E-Factura)',
    includeZugferd: 'Incluir ZUGFeRD / Factur-X XML',
    testConnection: 'Testar Ligação',
    testing: 'A testar...',
    pro: 'PRO',
    upgradeFtp: 'Atualize para Profissional para copiar faturas automaticamente para o seu servidor FTP/SFTP.',
    googleDrive: 'Google Drive',
    googleDriveDesc: 'Sincronizar faturas automaticamente para o seu Drive',
    connected: 'Ligado',
    disconnect: 'Desligar',
    notWorking: 'Não funciona? Vá a',
    googlePermissions: 'Permissões Google',
    removeThenReconnect: 'remova Invoice Browse e volte a ligar.',
    connectGoogleDrive: 'Ligar Google Drive',
    upgradeGoogleDrive: 'Atualize para Profissional para sincronizar faturas automaticamente com o Google Drive.',
    unsavedChanges: 'Alterações não guardadas',
    discard: 'Descartar',
    freePlanTitle: 'Automated delivery is not available on the free plan',
    freePlanDesc: 'Upgrade to Starter or Professional to automatically send invoices via email, FTP, or Google Drive.',
    emailLiquidTemplate: 'Email Liquid Template',
    liquidTemplateDesc: 'Copy and paste this code to your order confirmation template. Click {link} to open it.',
    here: 'here',
    save: 'Guardar',
  },
  bookkeeping: {
    pageTitle: 'Configurações',
    pageDescription: 'Configure your invoice settings',
    title: 'Configurações',
    owner: 'Proprietário',
    email: 'Email',
    phone: 'Telefone',
    keepDifferentNumbering: 'Manter numeração de faturas diferente para cada localização de encomenda',
    keepDifferentNumberingDisabled: 'Manter numeração de faturas diferente para cada localização de encomenda não é uma opção ativada com o seu plano.',
    locationEmailDesc: 'Isto permite-lhe enviar emails e faturas traduzidos com base na localização da encomenda: localização do inventário, endereço de envio ou faturação',
    upgradePlan: 'Atualize o seu plano',
    matchingCriteria: 'Critérios de Correspondência',
    locationId: 'ID da Localização',
    shippingCountryCode: 'Código de País do Endereço de Envio',
    billingCountryCode: 'Código de País do Endereço de Faturação',
    matchLocationDesc: 'Corresponder uma localização com base no ID de localização da encomenda, código de país do endereço de envio ou faturação.',
    companyInfo: 'Informações da Empresa',
    name: 'Nome',
    website: 'Website',
    registrationNumber: 'Número de Registo',
    taxId: 'NIF',
    addressSection: 'Morada',
    streetName: 'Nome da Rua',
    streetNumber: 'Número da Rua',
    zip: 'Código Postal',
    city: 'Cidade',
    region: 'Região',
    country: 'País',
    bankingInfo: 'Informações Bancárias',
    bankName: 'Nome do Banco',
    swift: 'Swift',
    currency: 'Moeda',
    iban: 'IBAN',
    invoicing: 'Faturação',
    decimalPlaces: 'Casas Decimais',
    invoicesPrefix: 'Prefixo de Faturas',
    currentInvoiceNumber: 'Número de Fatura Atual',
    creditNotesPrefix: 'Prefixo de Notas de Crédito',
    currentCreditNoteNumber: 'Número de Nota de Crédito Atual',
    lastInvoiceDate: 'Última Data de Fatura',
    noInvoicesYet: 'Ainda não foram criadas faturas.',
    confirmReverting: 'Confirmar Reversão do Sistema',
    allInvoicesAfter: 'Todas as faturas e os seus stornos emitidos após',
    willBeRemoved: 'serão removidos. Continuar com a reversão do sistema?',
    cancel: 'Cancelar',
    revert: 'Reverter',
    revertDesc: 'Reverter o sistema irá apagar todas as faturas criadas após a data selecionada.',
    revertToDate: 'Reverter para esta data',
    reverting: 'A reverter o sistema, por favor aguarde...',
    useOrderNumbering: 'Usar numeração de encomenda',
    showVat: 'Mostrar IVA nas faturas',
    overrideTaxes: 'Substituir Impostos',
    pricesIncludeTax: 'Os preços incluem imposto',
    productsTaxRate: 'Taxa de Imposto de Produtos',
    shippingTaxRate: 'Taxa de Imposto de Envio',
    skusSeparated: 'SKUs separados por ponto e vírgula',
    skusTaxRate: 'Taxa de Imposto por SKU',
    useOrderDates: 'Usar datas de criação de encomenda para faturas',
    convertCurrency: 'Converter preços para a moeda em que o cliente paga',
    unsavedChanges: 'Alterações não guardadas',
    discard: 'Descartar',
    save: 'Guardar',
  },
  drafts: {
    pageTitle: 'Rascunhos',
    pageDescription: 'Manage your draft orders',
    title: 'Rascunhos',
    download: 'Transferir',
    newDraft: 'Novo Rascunho',
    exporting: 'A exportar {status}%...',
    accessNotGranted: 'Acesso a Encomendas de Rascunho não concedido. Por favor',
    reLogin: 'inicie sessão novamente',
    toGrantPermissions: 'para conceder as permissões necessárias de "Encomendas de Rascunho".',
    pushFailed: 'Envio para Shopify falhou:',
    exportError: 'Erro de exportação:',
    confirmDelete: 'Tem a certeza de que deseja eliminar este rascunho?',
    incompleteCustomer: 'Os dados do cliente estão incompletos:',
    pushWithoutCustomer: 'O rascunho será enviado para Shopify sem dados do cliente. Continuar?',
    customerNotInShopify: 'Este cliente ainda não existe no Shopify.',
    warnings: 'Avisos:',
    createCustomerAndPush: 'Criar o cliente no Shopify e enviar a encomenda de rascunho?',
    downloadTitle: 'Descarregar rascunhos',
    cancel: 'Cancelar',
  },
  draftEdit: {
    number: "Número",
    prefix: "Prefixo",

    newDraft: 'Novo Rascunho',
    editDraft: 'Editar Rascunho',
    viewInShopify: 'Ver no Shopify',
    back: 'Voltar',
    createDraft: 'Criar Rascunho',
    saveChanges: 'Guardar Alterações',
    documentType: 'Tipo de Documento',
    draftOrder: 'Encomenda de Rascunho',
    quote: 'Orçamento',
    proforma: 'Proforma',
    manualInvoice: 'Fatura Manual',
    currency: 'Moeda',
    expiryDate: 'Data de Validade',
    status: 'Estado',
    draft: 'Rascunho',
    sent: 'Enviado',
    accepted: 'Aceite',
    customer: 'Cliente',
    firstName: 'Primeiro Nome',
    lastName: 'Apelido',
    email: 'Email',
    phone: 'Telefone',
    company: 'Empresa',
    taxId: 'NIF',
    billingAddress: 'Endereço de Faturação',
    address: 'Morada',
    aptSuite: 'Apartamento/Suite',
    city: 'Cidade',
    province: 'Província',
    countryField: 'País',
    zip: 'Código Postal',
    shippingAddress: 'Endereço de Envio',
    sameAsBilling: 'Igual ao de faturação',
    lineItems: 'Itens',
    shipping: 'Envio',
    shippingTitle: 'Título',
    shippingPlaceholder: 'ex. Envio Padrão',
    price: 'Preço',
    note: 'Nota',
    notePlaceholder: 'Nota interna ou mensagem para o cliente...',
    summary: 'Resumo',
    subtotal: 'Subtotal',
    discounts: 'Descontos',
    tax: 'Imposto',
    total: 'Total',
  },
  login: {
    pageTitle: 'Invoice Browse - Monthly batch invoicing',
    enterShopAddress: 'Introduza o endereço da sua loja',
    loginWith: 'Iniciar sessão com',
    createAccount: 'Criar uma nova conta',
    placeholder: 'nome-da-sua-loja',
    shopRequired: 'O nome da loja é obrigatório',
    login: 'Entrar',
    shopify: 'Shopify',
    terms: 'Termos e Condições',
    privacy: 'Política de Privacidade',
  },
  developer: {
    pageTitle: 'Developer Tools',
    pageDescription: 'Developer tools and API configuration',
  },
  leads: {
    pageTitle: 'Leads',
    pageDescription: 'Manage your leads',
  },
  review: {
    enjoying: 'Está a gostar do Invoice Browse?',
    description: 'Criou as suas primeiras faturas! Se a aplicação lhe está a ser útil, uma avaliação rápida na Shopify App Store ajuda-nos muito.',
    reward: 'Como agradecimento, iremos repor o seu contador de utilização mensal para 0',
    leaveReview: 'Deixar uma Avaliação',
    maybeLater: 'Talvez mais tarde',
  },
  footer: {
    copyright: '© 2026 Growth Connections',
  },
  joyride: {
    welcomeTitle: 'Bem-vindo ao Invoice Browse',
    welcomeContent: 'Deixe-me mostrar-lhe como pode usá-lo.',
    dashboardTitle: 'Painel',
    dashboardContent: 'O ecrã que está a ver é o painel principal. Aqui pode encontrar todas as encomendas e exportá-las para diferentes tipos de documentos como: faturas, guias de remessa e outros.',
    automationTitle: 'Facilite a sua vida',
    automationContent: 'Ative a automatização para criar faturas sempre que as encomendas são pagas ou reembolsadas.',
    templatesTitle: 'Personalizar modelos',
    templatesContent: 'Entre aqui para traduzir o seu modelo, personalizá-lo ou criar um novo.',
    deliveryTitle: 'Entrega',
    deliveryContent: 'Configure a nossa aplicação para copiar automaticamente os documentos criados para FTP, Google Drive, ou como anexos de emails.',
    settingsTitle: 'Configurações',
    settingsContent1: 'Ajuste o número de telefone da empresa, email e outros campos utilizados nos documentos.',
    settingsContent2: 'Altere o número inicial do documento ou apague documentos criados após uma data.',
    settingsContent3: 'Substitua as taxas de IVA para envio e produtos',
    settingsContent4: 'Altere as casas decimais para números',
    reviewTitle: 'Escrever uma avaliação',
    reviewContent: 'Apoie a nossa equipa escrevendo-nos uma boa avaliação!',
    tourTitle: 'Tour de boas-vindas',
    tourContent: 'Pode abrir este tour novamente a partir daqui.',
    createDocTitle: 'Crie o seu primeiro documento',
    createDocContent: 'Clique no botão Criar para criar o seu primeiro documento.',
    docNumberTitle: 'Número do documento',
    docNumberContent: 'O primeiro documento tem o número 1 atribuído. Se pretender começar com outro número, pode alterá-lo nas Configurações.',
    downloadDocTitle: 'Transferir documento',
    downloadDocContent: 'Clique no menu Transferir e selecione um modelo de documento para exportar a sua encomenda como PDF.',
  },
  common: {
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Fechar',
    discard: 'Descartar',
    delete: 'Eliminar',
    edit: 'Editar',
    create: 'Criar',
    loading: 'A carregar...',
    unsavedChanges: 'Alterações não guardadas',
    upgradePlan: 'Atualize o seu plano',
  },
  languageSelector: {
    label: 'Idioma',
    auto: 'Detetar automaticamente',
  },
  draftList: {
    draftNum: 'Rascunho #',
    shopifyId: 'Shopify ID',
    type: 'Tipo',
    customer: 'Cliente',
    total: 'Total',
    status: 'Estado',
    delivered: 'Entregue',
    date: 'Data',
    actions: 'Ações',
    noCustomer: 'Sem cliente',
    noDrafts: 'Nenhum rascunho ou orçamento encontrado.',
    loading: 'Carregando...',
    download: 'Baixar',
    default: 'Padrão',
    pending: 'Pendente',
    deliverNow: 'Entregar agora',
    deliveryDetails: 'Detalhes da entrega',
    sent: 'Enviado',
    failed: 'Falhou',
    deliverAgain: 'Entregar novamente',
    partial: 'Parcial',
    notDelivered: 'Não entregue',
    deliveryFailed: 'Entrega falhou',
    unknown: 'Desconhecido',
    edit: 'Editar',
    send: 'Enviar',
    pushToShopify: 'Enviar para Shopify',
    complete: 'Concluir',
    duplicate: 'Duplicar',
    delete: 'Excluir',
    quote: 'Orçamento',
    proforma: 'Proforma',
    draftOrder: 'Pedido rascunho',
    manualInvoice: 'Fatura manual',
  },
  draftSearch: {
    createdBtw: 'Criado entre',
    draftNum: 'Rascunho #',
    shopifyId: 'Shopify ID',
    customer: 'Cliente',
    status: 'Estado',
    type: 'Tipo',
    delivery: 'Entrega',
    any: 'Todos',
    draft: 'Rascunho',
    sent: 'Enviado',
    accepted: 'Aceito',
    expired: 'Expirado',
    converted: 'Convertido',
    cancelled: 'Cancelado',
    quote: 'Orçamento',
    proforma: 'Proforma',
    draftOrder: 'Pedido rascunho',
    manualInvoice: 'Fatura manual',
    delivered: 'Entregue',
    notDelivered: 'Não entregue',
    pending: 'Pendente',
    search: 'Pesquisar',
  },
  draftDownload: {
    title: 'Baixar rascunhos e orçamentos...',
    selectTemplate: 'Selecione um modelo da galeria para exportar rascunhos, orçamentos ou proformas.',
    allDraftsBetween: 'Todos os rascunhos entre',
    selectedDrafts: 'Rascunhos selecionados',
    and: 'e',
    status: 'Estado',
    documentType: 'Tipo de documento',
    any: 'Todos',
    draft: 'Rascunho',
    sent: 'Enviado',
    accepted: 'Aceito',
    expired: 'Expirado',
    converted: 'Convertido',
    cancelled: 'Cancelado',
    quote: 'Orçamento',
    proforma: 'Proforma',
    draftOrder: 'Pedido rascunho',
    manualInvoice: 'Fatura manual',
    format: 'Formato',
    noTemplates: 'Nenhum modelo encontrado',
    noTemplatesForType: 'Nenhum modelo encontrado para o tipo de documento "{type}".',
    installTemplates: 'Instalar modelos',
    toStartExporting: 'para começar a exportar.',
    noteChrome: 'Nota: Para download ideal, recomenda-se o Chrome e desativar bloqueadores de anúncios.',
    cancel: 'Cancelar',
    downloadIndividually: 'Baixar individualmente',
    downloadGrouped: 'Baixar agrupado',
  },
  templateEditor: {
    pageTitle: 'Template Editor',
    pageDescription: 'Edit and customize your invoice template',
    installNewTemplate: 'Instalar novo modelo',
    tabStyle: 'Estilo',
    tabContent: 'Conteúdo',
    tabTranslations: 'Traduções',
    tabSettings: 'Configurações',
    tabCode: 'Código',
    tabCopilot: 'Copiloto IA',
    logo: 'Logo',
    colorPalette: 'Paleta de cores',
    colorText: 'Texto',
    colorBg: 'Fundo',
    colorBorder: 'Borda',
    colorPrimary: 'Primária',
    colorAccent: 'Destaque',
    font: 'Fonte',
    fontDefault: 'Padrão (DM Sans)',
    fontSize: 'Tamanho da fonte',
    fontSizeDefault: 'Padrão (11.5px)',
    fontSizeCompact: 'Compacto',
    fontSizeSmall: 'Pequeno',
    fontSizeMediumSmall: 'Médio-pequeno',
    fontSizeMedium: 'Médio',
    fontSizeMediumLarge: 'Médio-grande',
    fontSizeLarge: 'Grande',
    fontSizeExtraLarge: 'Extra grande',
    documentTitle: 'Título do documento',
    documentTitlePlaceholder: 'ex. Fatura, Fatura fiscal...',
    noToggleSupport: 'Este modelo não suporta controles de alternância. Mude para um modelo da galeria para personalização completa.',
    sections: 'Seções',
    shippingAddress: 'Endereço de entrega',
    bankPaymentDetails: 'Dados bancários/pagamento',
    paymentStatusBadge: 'Badge de status de pagamento',
    orderNotes: 'Notas do pedido',
    trackingFulfillment: 'Rastreamento/expedição',
    termsConditions: 'Termos e condições',
    signatureLines: 'Linhas de assinatura',
    qrCode: 'Código QR',
    lineItems: 'Itens',
    taxColumns: 'Colunas de impostos (IVA)',
    productSku: 'SKU do produto',
    productImages: 'Imagens do produto',
    discountBreakdown: 'Detalhamento de descontos',
    itemWeight: 'Peso do item',
    hsCode: 'Código HS (alfândega)',
    mergeDiscounts: 'Incorporar descontos no preço do produto',
    showOrderDiscountAsSummary: 'Mostrar o desconto da encomenda como linha de resumo',
    totals: 'Totais',
    subtotalBeforeTax: 'Subtotal (antes de impostos)',
    taxBreakdownByRate: 'Detalhamento de impostos por taxa',
    shippingCostSeparate: 'Custo de envio como linha separada',
    dueDate: 'Data de vencimento',
    formatting: 'Formatação',
    dateFormat: 'Formato de data',
    decimalPlaces: 'Casas decimais',
    paymentTerms: 'Condições de pagamento',
    paymentTermsNone: 'Nenhuma',
    thankYouMessage: 'Mensagem de agradecimento',
    thankYouPlaceholder: 'Obrigado pela sua compra!',
    countryMatchTitle: 'Usar este modelo quando o endereço de entrega ou faturamento corresponder a este país',
    addressType: 'Tipo de endereço',
    addressDisabled: 'Desativado',
    addressShipping: 'Endereço de entrega',
    addressBilling: 'Endereço de faturamento',
    country: 'País',
    anyCountry: 'Qualquer país',
    countryMatchDesc: 'Quando ativado, este modelo será usado automaticamente para pedidos onde o endereço selecionado corresponde ao país escolhido.',
    languagePreset: 'Idioma predefinido',
    selectLanguage: 'Selecionar idioma...',
    languagePresetDesc: 'Selecionar um idioma preenche todos os rótulos abaixo. Você pode personalizar campos individuais depois.',
    paperSize: 'Tamanho do papel',
    format: 'Formato',
    orientation: 'Orientação',
    portrait: 'Retrato',
    landscape: 'Paisagem',
    margin: 'Margem (cm)',
    template: 'Modelo',
    templateName: 'Nome',
    systemAlias: 'Alias do sistema',
    systemAliasDesc: 'para rotas URL POS/Admin',
    systemAliasNone: 'Nenhum',
    defaultTemplate: 'Modelo padrão',
    defaultTemplateDesc: 'Usado para links diretos compartilhados com clientes.',
    posRouteDesc: 'Mapeia para /template/[alias]/receipt.pdf para integração POS.',
    documentType: 'Tipo de documento',
    invoiceCreditNote: 'Fatura + Nota de crédito',
    order: 'Pedido',
    invoiceOnly: 'Apenas fatura',
    quoteEstimate: 'Orçamento/Estimativa',
    proformaInvoice: 'Fatura proforma',
    refund: 'Reembolso',
    stornoInvoice: 'Fatura de estorno',
    creditNoteOnly: 'Apenas nota de crédito',
    reportLiquid: 'Relatório (apenas Liquid)',
    hideRemovedItems: 'Ocultar itens removidos/reembolsados',
    location: 'Localização',
    locationEmpty: 'Deixe vazio para usar em todas as localizações',
    dangerZone: 'Zona de perigo',
    dangerZoneDesc: 'Remover permanentemente este modelo da sua conta.',
    removeTemplate: 'Remover modelo',
    bodyTemplate: 'Modelo principal',
    bodyTemplateDesc: 'Usa sintaxe Mustache ou Liquid. Clique num snippet:',
    rowTemplate: 'Modelo de linha',
    rowTemplateDesc: 'Renderizado uma vez por item. Clique num snippet:',
    variableReference: 'Referência de variáveis',
    formatCode: 'Formatar código',
    insert: 'Inserir',
    copy: 'Copiar',
    loadModelContinue: 'Carregar modelo e continuar',
    cancel: 'Cancelar',
    copilotPlaceholder: 'Tente: traduzir para português, mostrar colunas de imposto, adicionar código de barras...',
    trySamplePrompts: 'Try these sample prompts:',
    undo: 'Desfazer',
    redo: 'Refazer',
    aiThinking: 'IA está pensando...',
    proposedChanges: 'Alterações propostas',
    applyChanges: 'Aplicar alterações',
    dismiss: 'Descartar',
    aiEngineReady: 'Motor IA pronto',
    loadingAiModel: 'Carregando modelo IA...',
    aiEngineOff: 'Motor IA desligado —',
    loadForAdvanced: 'carregar para edição avançada',
    instantCommands: 'traduzir, mostrar/ocultar seções, adicionar snippets, alterar fonte/cores/papel',
    aiEngineDesc: 'edições HTML estruturais, alterações de layout, modificações personalizadas',
    aiLocalDesc: 'O modelo é executado localmente via WebGPU — nenhum dado sai do seu navegador.',
    aiUpgradeDesc: 'atualize para Starter ou Professional para desbloquear edição IA avançada.',
    upgrade: 'Atualizar',
    loadAiQuestion: 'Carregar motor IA?',
    loadAiDesc: 'O modelo IA será baixado e executado localmente via WebGPU. Requer ~1-3 GB de VRAM/RAM livre e uma GPU moderna.',
  },
};



// WEBPACK FOOTER //
// app/intl/locales/pt.js